/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Downloads sensor data as a CSV file.
 * The CSV will contain parsed name, 2 nextlines and two columns: x and y, with values formatted to three decimal places.
 * The third row will contain the headers specified by headerA and headerB.
 * @function downloadSensorCsv
 * @param tableData 
 * @param name   
 * @param headerA 
 * @param headerB
 * @returns {Promise<void>} A promise that resolves when the download is initiated. 
 */
const downloadSensorCsv = async (tableData: any[], name: string, headerA: string, headerB: string) => {

    const csvData = tableData.map(row => ({
        x: row.x.toFixed(3),
        y: row.y.toFixed(3)
    }));

    const csvContent = "data:text/csv;charset=utf-8," 
        + name.substring(name.indexOf("-") + 1).trim() + "\n\n"
        + `${headerA},${headerB}\n`
        + csvData.map(e => `${e.x},${e.y}`).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    const fileName=`${name}.csv`
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export {downloadSensorCsv}